import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export enum SelectableCardVariant {
  DEFAULT = 'default',
  OPTION = 'option',
}

export type SelectableCardProps = {
  id?: string;
  testId?: string;
  iconName?: TUNDR_ICONS;
  title: string;
  description?: string;
  selected?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  selectable?: boolean;
  singleCard?: boolean;
  text?: string;
  variant?: SelectableCardVariant;
  tooltipText?: string;
  tooltipDescription?: string;
  smallGap?: boolean;
};
